import React from "react";
import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ProjectPDFLink,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeProject } from "lib/redux/types";
import { TemplateSixPDFSectionWithSubsections as TemplateSixPDFSection } from "./common";

export const Project = ({
  heading,
  projects,
  themeColor,
  isPDF,
}: {
  heading: string;
  projects: ResumeProject[];
  themeColor: string;
  isPDF: boolean;
}) => {
  return (
    <TemplateSixPDFSection themeColor={themeColor} heading={heading}>
      {projects.map(
        ({ project, startDate, endDate, descriptions, projectLink }, idx) => (
          <View
            key={idx}
            style={{ marginTop: spacing[2], marginBottom: spacing[2] }}
            wrap={false} // Prevent individual project items from splitting across pages
          >
            <View style={styles.flexRowBetween}>
              <View style={{ ...styles.flexRow, gap: spacing[2] }}>
                <ResumePDFText bold={true}>
                  {project}
                </ResumePDFText>
                {projectLink && (
                  <ProjectPDFLink src={projectLink}>
                    <ResumePDFIcon
                      type="url"
                      isPDF={isPDF}
                      themeColor={themeColor}
                    />
                  </ProjectPDFLink>
                )}
              </View>
              <ResumePDFText>
                {startDate && endDate
                  ? `${startDate} - ${endDate}`
                  : startDate || endDate}
              </ResumePDFText>
            </View>
            <View
              style={{
                ...styles.flexCol,
                marginTop: spacing[2],
              }}
            >
              <ResumePDFDescription items={descriptions} />
            </View>
          </View>
        )
      )}
    </TemplateSixPDFSection>
  );
};
